import axios from 'axios'
import { reqSuccess, reqError, resSuccess, resError } from './interceptors'

axios.defaults.baseURL = '/api'
axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.interceptors.request.use(reqSuccess, reqError)
axios.interceptors.response.use(resSuccess, resError)

let http = {}

const getNameFromPath = (path) => {
  const start = path.lastIndexOf('/') + 1
  const end = path.lastIndexOf('.')
  return `${path.substring(start, end)}`
}

const modelsContext = require.context('./packages', false, /\.js$/)
modelsContext.keys().forEach(path => {
  const name = getNameFromPath(path)
  const methods = modelsContext(path)
  http[name] = methods
})

export default http
